jQuery(function($) {
    var headerHeight = 0; // ヘッダー追従でない場合 // if not header-following
	// var headerHeight = $('header').innerHeight(); // ヘッダー追従の場合 // if header following
    $('a[href^="#"]').click(function(){
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        if ( target.length > 0 ) {
            var position = target.offset().top - headerHeight;
            $("html, body").animate({scrollTop:position}, 550, "swing");
            return false;
        }
    });
})

// ブログサムネイル 中心でトリミング // Blog thumbnail Crop at center
jQuery(function($) {
    if ( $('.obj_image').length > 0 ) {
        objectFitImages('.obj_image');
    }
});


// レスポンシブ画像切り替え imgにclass「js-image-switch」// responsive image switch class "js-image-switch" in img
jQuery(function($) {

	if ( $('.js-image-switch').length > 0 ) {

		var $elem = $('.js-image-switch');
		var sp = '_sp.';
		var pc = '_pc.';
		// 画像を切り替えるウィンドウサイズ // Window size to switch images
		var replaceWidth = 768;

		function imageSwitch() {
			var windowWidth = parseInt($(window).width());
			$elem.each(function() {
				var $this = $(this);
				if(windowWidth >= replaceWidth) {
				$this.attr('src', $this.attr('src').replace(sp, pc));
				} else {
					$this.attr('src', $this.attr('src').replace(pc, sp));
				}
			});
		}
		imageSwitch();

		var resizeTimer;
		$(window).on('resize', function() {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function() {
				imageSwitch();
			}, 200);
		});
	}
});

// ドロワーメニュー // Drawer menu
jQuery(function($) {
    if ($('#toggle').length > 0) {
		$('#toggle').click(function () {
			$(this).toggleClass('toggle_active');
			$('#drawer_layer').fadeToggle();
			$('body').toggleClass('drawer_open');

			if ($(this).hasClass('toggle_active')) {
				$('nav').addClass('is_open');
				$('nav').removeClass('is_close');
			} else {
				$('nav').removeClass('is_open');
				$('nav').addClass('is_close');
			}
		});

		$('#drawer_layer').click(function () {
			$(this).fadeOut();
			$('#toggle').removeClass('toggle_active');
			$('body').removeClass('drawer_open');
			$('nav').removeClass('is_open');
			$('nav').addClass('is_close');
		});

		// エリア内リンク用 // For links within an area
		$('nav a').on('click', function(){
			// if (window.innerWidth <= 768) {
			if ($('#toggle:visible').length > 0) {
				$('#toggle').click();
			}
		});
	}

});

// Calendar Reservation
jQuery(function($) {
    if ($('.c-calendar').length) {
        const threshold = 332;

        $(window).on("scroll resize", function() {
            const scrollTop = $(window).scrollTop();
            const windowWidth = $(window).width();

                if (scrollTop > threshold) {
                    $(".c-calendar").addClass("fixed");
                } else {
                    $(".c-calendar").removeClass("fixed");
                }
        });

        $(document).on("click", ".c-calendar", function() {
            $(this).toggleClass("show");
        });
    }
});


// Tab action
// jQuery(function($) {
//   $(".tab-btn").on("click", function () {
//     const tabId = $(this).data("tab");

//     $(".tab-btn").removeClass("active");
//     $(".tab-content").removeClass("active");

//     $(this).addClass("active");
//     $("#" + tabId).addClass("active");
//   });

//   $(".tab-btn:first").trigger("click");
// });

// Modal action
jQuery(function($) {
    $('.modal').hide();

    $('.profile-item').on('click', function (e) {
        e.preventDefault();
        const modalId = $(this).data('modal');
        $('#' + modalId).fadeIn();
        $("body").addClass('noscroll');
    });

    $('.close-modal').on('click', function () {
        $(this).closest('.modal').fadeOut();
        $("body").removeClass('noscroll');
    });

    $(document).on('click', function (e) {
    if ($(e.target).is('.modal') && !$(e.target).closest('.modal-content').length) {
        $(e.target).fadeOut();
        $("body").removeClass('noscroll');
    }
});

    // モーダル内スクロール
    $(".modal-top").click(function() {
        // クリックされた「上部に戻る」ボタンの直近のスクロール可能な親要素を取得
        $(this).closest(".modal").find(".modal-content__inner-right").animate({ scrollTop: 0 }, 300);
    });

});

// fade out sidebar
jQuery(function($) {
    if ($('.c-calendar').length || $('.c-cta--fixed').length) {
        if ($(window).width() > 768) {
            $(window).on("scroll resize", function () {

                const footerTop = $('.l-footer__top-sitemap').offset()?.top || 0;
                const scrollTop = $(window).scrollTop();
                const windowHeight = $(window).height();

                if (scrollTop + windowHeight >= footerTop) {
                    $('.c-calendar, .c-cta--fixed').fadeOut();
                } else {
                    $('.c-calendar, .c-cta--fixed').fadeIn();
                }
            });

            $(window).trigger('resize');
        };
    }
});

// ヘッダーの固定エフェクト // Fixed header effect
jQuery(function($) {
	var $header = $('header');
	$(window).scroll(function() {
		if ($(window).scrollTop() > 50) {
			$header.addClass('fixed');
		} else {
			$header.removeClass('fixed');
		}
	});
});


jQuery(function($){
    $("#more-btn").click(function(){
        let isExpanded = $(this).data("expanded") || false;

        if (!isExpanded) {
            $(".c-profile-main__txt h3, .c-profile-main__txt p").slideDown(500);;  // 全て表示
            $(this).text("▲閉じる");
        } else {
            $(".c-profile-main__txt h3:not(:first-of-type), .c-profile-main__txt p:not(:first-of-type)").slideUp(500);; // 2つ目以降を非表示
            $(this).text("▼もっと見る");
        }

        $(this).data("expanded", !isExpanded);
    });
});

new ScrollHint(".js-scroll", {
  i18n: {
    scrollable: "横スクロール",
  },
});
